import { ProductMedias, ProductMedia } from '../../../../types/interfaces';

import { CloudinaryMediaTransformer, UrlFetchCloudinaryTransformer } from './MediasTransformer';

export class TransformerFactory {
  static getTransformer(productMedias: ProductMedias) {
    if (TransformerFactory.areMediasInCloudinary(productMedias)) {
      return new CloudinaryMediaTransformer();
    }
    return new UrlFetchCloudinaryTransformer();
  }

  private static areMediasInCloudinary(catalogMedias: ProductMedias) {
    return (
      catalogMedias.common.some(TransformerFactory.isInCloudinary) ||
      catalogMedias.combinationMedias.some((combinationMedia) =>
        combinationMedia.medias.some(TransformerFactory.isInCloudinary)
      )
    );
  }

  private static isInCloudinary(media: ProductMedia) {
    return media.video || media.image?.url.includes('t_pdpHeroGallery');
  }
}
